<template>
    <b-form id="source_submit" @submit="onSubmit">
        <div class="row">
            <div class="col-sm-12">
                <b-form-group label="Название"
                              label-for="title">
                    <b-form-input id="title"
                                  type="text"
                                  v-model="form.title">
                    </b-form-input>
                    <span class=" alert-danger" v-if="submitted && !form.title">Заполните название</span>
                </b-form-group>
                <b-form-group label="Группа">
                    <v-select :options="groups" v-model="form.group">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !form.group">Выберите группу</span>
                </b-form-group>
                <b-form-group label="Валюта">
                    <v-select :options="currency" required v-model="form.currency">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !form.currency">Добавьте валюту</span>
                </b-form-group>
                <b-form-group label="Ответственный МБ">
                  <v-select label="name" :options="activeUsers"
                            required v-model="form.selectedResponsibleBuyer" placeholder="Ответственный МБ" >
                    <span slot="no-options">Совпадений не найдено.</span>
                  </v-select>
                </b-form-group>
                <b-dropdown right variant="primary" split text="Сохранить и выйти" v-on:click="onSubmit($event, true)"
                            class="float-right">
                    <b-dropdown-item v-on:click="onSubmit($event, true)">Сохранить и выйти</b-dropdown-item>
                    <b-dropdown-item v-on:click="onSubmit($event, false)">Сохранить и создать</b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="form-errors"></div>
    </b-form>
</template>
<script>
    import OffersService from '../../../services/offersDataService'
    import SourcesService from '../../../services/sourcesDataService'
    import UsersService from '../../../services/usersDataService'

    export default {
        name: 'CreateSourceModal',
        components: {
            OffersService: OffersService
        },
        data() {
            return {
                form: {
                    title: null,
                    group: null,
                    currency: null,
                    selectedResponsibleBuyer: null
                },
                groups: [],
                currency: [],
                submitted: false,
                activeUsers: [],
            }
        },
        methods: {
            onSubmit(evt, close) {
                evt.preventDefault();
                this.submitted = true;

                if (!this.form.title || !this.form.group || !this.form.currency) {
                    evt.preventDefault();

                    return;
                }

                if (this.form.selectedResponsibleBuyer) {
                  this.form.responsible_buyer_id = this.form.selectedResponsibleBuyer.id
                }

                SourcesService.saveSource(this.form)
                    .then(function (response) {
                        if (close && response) {
                            window.location.href = '/sources';
                        } else if (!close && response) {
                            this.form = {
                                title: null,
                                group: null,
                                currency: null,
                            };
                            this.submitted = false;
                        }
                    }.bind(this))
            },
            getGroups() {
                SourcesService.getGroups()
                    .then(function (groups) {
                        this.groups = groups;
                    }.bind(this))
            },
            getActiveUsers() {
              UsersService.getActiveUsers()
                .then(function (users) {
                  this.activeUsers = users;
                }.bind(this))
            },
            getCurrency() {
                OffersService.getCurrency()
                    .then(function (response) {

                        this.currency = response;
                    }.bind(this))
            },
        },
        beforeMount() {
            this.getCurrency();
            this.getGroups();
            this.getActiveUsers();
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/front/modals/CreateSourceModal.vue